import { observable, computed } from 'mobx';

export class CheckoutPageModel {
  constructor() {}

  @observable
  step: number = 0;
}

export type CheckoutPageField = 'name' | 'number' | 'exp' | 'cvc' | 'address_zip';